import React, { Component } from 'react';

import Icon from 'antd/lib/icon';
import {MdOutlineEmail} from 'react-icons/md/'
import {MdClose} from 'react-icons/md/'
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import styled from 'styled-components';
import {
  fontFamily, hasExpiringProUpsell, hasTreeActivationBanner, hasActive_notice, activeNoticeBannerHeight,
} from '../../library/constants';
import {
  shrinkWordsWidth,
  toUpper,
  isValidEmail
} from '../../library/calc';
import {
  trAvailable,
  translatePhrase,
} from '../Translate';

import './index.css';
// import 'antd/lib/button/style/css';
// import 'antd/lib/input/style/css';
// import 'antd/lib/input/style/';
// import 'antd/dist/antd.css';

// const FormItem = Form.Item;
const Search = Input.Search;

class InviteForm extends Component {

  constructor(props, context){

    super(props, context);

    const message = 'Error';
    const type = 'error';
    const position = 'bc';
    const duration = 3;
    const onOpen = () => {
      if(typeof(this.props.fromSidePanel) === 'undefined') this.props.setCanHideInviteModal(false);
    }
    const onClose = () => {
      if(typeof(this.props.fromSidePanel) === 'undefined') this.props.setCanHideInviteModal(true);
    }
    this.notifyOptions = {which:'InviteMsg', message, type, position, duration, onOpen, onClose};

  }

  onInvite(email){

    if(typeof(this.props.fromSidePanel) === 'undefined'){
      this.props.setCanHideInviteModal(false);
    }

    const errReturned = isValidEmail(email);

    if (errReturned === true) {

          const prId = this.props.invitePrId;
          const node = this.props.inviteNode;
          const callbackWhen = 'after';

          const callback = ( {serverMessage} ) => {
            this.props.callHookForMessageAlert({type: 'success', content: 'Invitation sent', title: 'Success', duration: 5});
            // this.props.notifyWithAtom({...this.notifyOptions, description: serverMessage});
            // if(typeof(serverMessage) !== 'undefined'  &&
            //  serverMessage !== 'Localhost Dev server success'
            // ) {
            //   const description = serverMessage;
            //   this.props.notifyWithAtom({...this.notifyOptions, description});
            //   return;
            // }
            // this.props.inviteIsSent();
            if(typeof(this.props.fromSidePanel) === 'undefined') this.props.setCanHideInviteModal(true);
            if(typeof(this.props.fromSidePanel) === 'undefined') this.props.hideInviteModal();
            // setTimeout(() => {
            // }, timeDelayForInviteIsSent);
          }

          this.props.postInvite({email, prId, node, callbackWhen, callback});

    } else {

      let message = undefined;
      for( let key in errReturned){
        message = errReturned[key];
      }

      const description = `${message}`;

      this.props.notifyWithAtom({...this.notifyOptions, description});

    }

  }

  render () {

    // const { getFieldDecorator } = this.props.form;

    const enterEmailAddressLabel = shrinkWordsWidth({word: toUpper(this.props.translatedLabels['Enter email address'].translatedLabel), maxLength: 27});

    return (
      <div id="invite-form">
        <Form onSubmit={this.handleSubmit}>
              <Search
                prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                style={{ width: 260 }}
                placeholder={enterEmailAddressLabel}
                enterButton={`${toUpper(this.props.translatedLabels['invite'].translatedLabel)}`}
                onSearch={this.onInvite.bind(this)}
                onClick={(evt)=>{
                  evt.stopPropagation();
                }}
                size="small" />
        </Form>

      </div>
    )
  }

}

export class EntryForm extends Component {

  componentDidMount(){

    this.invitation = `Send an invitation to this person.`;

    if(trAvailable()) {
      this.invitation = translatePhrase({
        phrase: 'Send an invitation to this person.'
      })
    }

    const inputElement = document.querySelector('#invite-form input');

    inputElement.addEventListener('keydown', function(event) {

        if( event.keyCode === 224 ){
          event.stopPropagation();
        }

    });

    inputElement.addEventListener('keyup', function(event) {

        if( event.keyCode === 224 ){
          event.stopPropagation();
          event.preventDefault();
        }

    });

  }

  render () {

    const isShortPedigreeNode = () =>{
      return this.props.inviteNode && this.props.nodeObjs[this.props.inviteNode] && this.props.isPedigree &&
      !this.props.nodeObjs[this.props.inviteNode].pedigreeIsTall
    }

    const translatedPhraseDivStyle = {
      margin: `${ isShortPedigreeNode() ? 2 : 5.5}px 0px`,
      fontFamily: fontFamily,
      fontSize: '14px',
    }

    /*

      Side Panel

     */

    if(typeof(this.props.fromSidePanel) !== 'undefined' && this.props.fromSidePanel){

      return (
        <div>
          <div>

            <div style={{
                width: `100%`,
                height: '25px',
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#636363',
                textDecoration: 'underline',
                marginBottom: '10px',
              }}>
              {`${toUpper(this.props.translatedLabels['invite'].translatedLabel)}`}
            </div>

            {

              trAvailable()

                ?

              <div style={translatedPhraseDivStyle} dangerouslySetInnerHTML={{__html: this.invitation}} />

                :

              <div  style={translatedPhraseDivStyle} >{`${this.invitation}`}</div>

            }

          </div>
          <div style={{
              padding: `0px 0px 18px 12px`,
              }
            }>
            <InviteForm
              notifyWithAtom={this.props.notifyWithAtom}
              callHookForMessageAlert={this.props.callHookForMessageAlert}
              setCanHideInviteModal={this.props.setCanHideInviteModal}
              fromSidePanel={this.props.fromSidePanel}
              postInvite={this.props.postInvite}
              invitePrId={this.props.invitePrId}
              inviteNode={this.props.inviteNode}
              hideInviteModal={this.props.hideInviteModal}
              inviteIsSent={this.props.inviteIsSent}
              inviteFullName={this.props.inviteFullName}
              translatedLabels={this.props.translatedLabels}
            />
          </div>
        </div>
      )
    };


    /*
      Invite Modal
     */

    const paddingTop = (
      isShortPedigreeNode()
        ?
          0
        :
          9
      );

    const paddingBottom = 0;

    return (
        <div>
          <div style={{
              width: '340px',
              padding: `${paddingTop}px 0px ${paddingBottom}px`,
              margin: 'auto'}
            }>
            <div style={{
                position: 'absolute',
                top: `${paddingTop - ( isShortPedigreeNode() ? 9:12)}px`,
                right: '2px',
            }}>
              <MdClose
                size={20}
                color={'#bfbfbf'}
                onClick={(evt)=>{/* event handler not needed for click*/}}
                cursor={'pointer'}
              />
            </div>

            <MdOutlineEmail size={40}  color='white' />


            {

              trAvailable()

                ?

              <div style={translatedPhraseDivStyle} dangerouslySetInnerHTML={{__html: this.invitation}} />

                :

              <div  style={translatedPhraseDivStyle} >{`${this.invitation}`}</div>

            }

          </div>
          <div>
            <InviteForm
              notifyWithAtom={this.props.notifyWithAtom}
              callHookForMessageAlert={this.props.callHookForMessageAlert}
              setCanHideInviteModal={this.props.setCanHideInviteModal}
              postInvite={this.props.postInvite}
              invitePrId={this.props.invitePrId}
              inviteNode={this.props.inviteNode}
              hideInviteModal={this.props.hideInviteModal}
              inviteIsSent={this.props.inviteIsSent}
              inviteFullName={this.props.inviteFullName}
              translatedLabels={this.props.translatedLabels}
            />
          </div>
        </div>
    )}
}

class InviteSent extends Component {

  render () {
    return (
        <div style={{
          width: '100%',
          position: 'absolute',
          bottom: '16px',
          color: 'blue',
          fontSize: '16px',
        }}>
          Invitation has been sent
        </div>
    )}
}

class InviteModal extends Component {

  constructor(props, context){

    super(props, context);
    this.state = {
      inviteSent: false,
    };

  }


  inviteIsSent(){
    this.setState({inviteSent:true});
  }

  render () {

    const Overlay = styled.div`
      width: 100%;
      height: 100%;
      text-align: center;
      position: fixed;
      top: ${this.props.canvasTop}px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      z-index: 99999999999999999;
    `;

    let top = 60;

    if(hasActive_notice || hasTreeActivationBanner || hasExpiringProUpsell){
      top += activeNoticeBannerHeight + 8;
    }

    const divStyle = {
      maxHeight: 150,
      maxWidth: 350,
      width: '350px',
      height: '150px',
      position: 'absolute',
      top: `${top}px`,
      bottom: '0',
      left: '0',
      right: '0',
      margin: 'auto'
    }

    return (
      <Overlay

        onClick={()=>{
          // console.log('clicking overlay');
          this.props.hideInviteModal();
        }}

        onTouchMove={(e)=>{
           e.preventDefault();
        }}
      >
        <div
          style={divStyle}
        >

          {

            !this.state.inviteSent

            ?

              <EntryForm
                notifyWithAtom={this.props.notifyWithAtom}
                nodeObjs={this.props.nodeObjs}
                isPedigree={this.props.isPedigree}
                callHookForMessageAlert={this.props.callHookForMessageAlert}
                setCanHideInviteModal={this.props.setCanHideInviteModal}
                postInvite={this.props.postInvite}
                invitePrId={this.props.invitePrId}
                inviteNode={this.props.inviteNode}
                hideInviteModal={this.props.hideInviteModal}
                inviteIsSent={this.inviteIsSent.bind(this)}
                inviteFullName={this.props.inviteFullName}
                translatedLabels={this.props.translatedLabels}
              />

            :

            <InviteSent />

          }

        </div>
      </Overlay>
    )}
}


export default InviteModal;
